import { useNavigate } from "react-router";
import Skills from "./Skills";

import { FaAnglesDown, FaAnglesUp } from "react-icons/fa6";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { ImNewTab } from "react-icons/im";
import { LuLogOut } from "react-icons/lu";


export default function Home() {
  const navigate = useNavigate()

  const [showModal, setShowModal] = useState(false);
  const [currentPdf, setCurrentPdf] = useState<string | null>(null);


  const openModal = (pdfUrl: string) => {
    setCurrentPdf(pdfUrl);
    setShowModal(true);
  };
  const isMobile = window.innerWidth < 1024;
  const closeModal = () => {
    setShowModal(false);
    setCurrentPdf(null);
  };

  const [nuGrades, setNuGrades] = useState(false)
  const [nuInfo, setNuInfo] = useState(false)
  const [pittInfo, setPittInfo] = useState(false)
  const [aubInfo, setAubInfo] = useState(false)
  const [clwInfo, setClwInfo] = useState(false)
  return (
    <>

    <div className="container-background-1">
      <div className="hero-section">
        <div className="hero-text">

          <h1>Discover how I turn data into actionable solutions</h1>
          <button className="explore-button me-2" onClick={() => {
              navigate("/Rayan/Portfolio")
            }}>
            View Portfolio
          </button>
        </div>
        <div className="hero-image">
          <img src="/images/rayanh.jpeg" alt="Profile" />
          <div className="thought-bubbles-container">
        <span className="thought" style={{ top: "10%", left: "10%" }}>
          Data Science
        </span>
        <span className="thought" style={{ top: "5%", right: "15%" }}>
          Projects
        </span>
        <span className="thought" style={{ bottom: "5%", left: "5%" }}>
          AI
        </span>
        <span className="thought" style={{ bottom: "5%", right: "-10%" }}>
          Research
        </span>
        <span className="thought" style={{ top: "30%", left: "-10%" }}>
          Machine Learning
        </span>
        <span className="thought" style={{ top: "30%", right: "-10%" }}>
          Web Development
        </span>
        <span className="thought" style={{ bottom: "30%", left: "-15%" }}>
          Courses
        </span>
        <span className="thought" style={{ bottom: "25%", right: "-25%" }}>
          Innovation
        </span>
      </div>
        </div>
      </div>
    </div>

    <Skills/>

    <div className="custom-shape-divider-top-1735500841">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill border-0"></path>
      </svg>
    </div>



    <div className="education-section mt-2">

            <h1 className="education-title">EDUCATION</h1>



          <div className="nu">

            <div className="nu-container">
                <h5>Northeastern University (Fall 2024-present)</h5>

                <div className="nu-info">
                  <ul>
                  <li><span style={{fontWeight:"bold"}}>Program: </span>Master of Science in Data Science (expected 2026)</li>
                  <li><span style={{fontWeight:"bold"}}>Major: </span>Data Science</li>
                    <li><span style={{fontWeight:"bold"}}>GPA: </span>4.0</li>

                  </ul>
                  <button className="btn btn-info me-2" onClick={()=>openModal("/papers/NU_Transcript.pdf")}>View Transcript</button>
                  <button className="btn btn-info" onClick={()=>{setNuInfo((prev:any)=> !prev)}}>Learn More</button>
                </div>
  
              {nuInfo && (
              <div style={{  display: "flex", 
                justifyContent: "center", 
                alignItems: "center", }}>
                <div className="alert alert-info w-100"  style={{position:"absolute", maxWidth:"500px"}}>
                    <button
                        className="btn-close float-end"
                        onClick={() => setNuInfo(false)}
                    ></button>
                <p style={{overflow:"wrap", maxWidth:"500px"}}>I began my Master's in Data Science at Northeastern University 
                  to deepen my knowledge and gain practical experience in the field. With the university’s strong reputation for its Co-op program, 
                  I am eager to apply my skills in a professional setting and further develop my expertise.
                </p>

                </div>
                </div>
            )}
              </div>
              <img src="/images/nu.png" alt="nu logo" />

          </div>

          <div className="arrow mb-5"><FaAnglesUp className="fs-1"/></div>
          <div className="pitt">

            <img src="/images/pitt.svg" alt="pitt logo" />
            <div className="pitt-container mt-3">
              <h5>University of Pittsburgh (Fall 2021-Fall 2023)</h5>
              <div className="pitt-info">
                <ul>
                <li><span style={{fontWeight:"bold"}}>Diploma: </span>Bachelor of Science in Computer Engineering</li>
                <li><span style={{fontWeight:"bold"}}>Major: </span>Computer Engineering</li>
                  <li><span style={{fontWeight:"bold"}}>GPA: </span>3.76</li>
                  <li><span style={{fontWeight:"bold"}}>Activities: </span>Institue of Electronics and Electrical Engineering (IEEE), Summer Undergraduate Research program (SURP) at The Chinese University of Hong Kong
                  </li>
                  
                </ul>
                <button className="ms-4 btn btn-info me-2" onClick={() => openModal("/images/PittDiploma.jpeg")}>View Diploma</button>
                <button className="btn btn-info me-2" onClick={() => openModal("/papers/Official_Transcript_Pitt.pdf")}>View Transcript</button>
                <button className="btn btn-info" onClick={()=>setPittInfo((prev:any)=>!prev)}>Learn More</button>
              </div>
              {pittInfo && (
                <div style={{  display: "flex", 
                  justifyContent: "center", 
                  alignItems: "center", }}>
                <div className="alert alert-info w-100" style={{position:"absolute", maxWidth:"500px"}}>
                    <button
                        className="btn-close float-end"
                        onClick={() => setPittInfo(false)}
                    ></button>
                <p style={{overflow:"wrap", maxWidth:"500px"}}>I transferred to the University of Pittsburgh from the American University if Beiurt for a fresh
                  start <a href="#/Rayan/About" style={{textDecoration:"none"}}>(About Me <ImNewTab className="mb-1"/>)</a>. There, I was a member of the IEEE (Spring 2022-Fall 2023) club and attented seminars, workshops, and meetings to learn more
                  about various engineering topics and discucss new technologies with faculty members and colleagues. Additionally, I took part in a summer research program
                  (SURP) at The Chinese University of Hong Kong in Summer of 2022 (<button className="border-0 text-primary" style={{background:"none", padding:"0"}} onClick={() => openModal("/papers/transcripts_cuhk.pdf")}>View Transcript</button>).
                  I contributed to a paper on robotics used for biomedical purposes which got published on MDPI <button className="btn btn-link mb-1" style={{padding:"0", margin:"0", textDecoration:"none"}} onClick={() => window.open("https://doi.org/10.3390/machines11030325", "_blank")}>(View Paper <LuLogOut className="mb-1"/>)</button>.
                </p>
                </div>
                </div>
            )}

            </div>


            </div>

            <div className="arrow mb-5"><FaAnglesUp className="fs-1" /></div>

          <div className="aub">
          <div className="aub-container">
              <h5>American University of Beirut (Fall 2019-Spring 2021)</h5>
              <div className="aub-info">
                <ul>
                  <li><span style={{fontWeight:"bold"}}>Major: </span>Computer and Communication Engineering</li>
                  <li><span style={{fontWeight:"bold"}}>Major GPA: </span>3.3</li>
                  <li><span style={{fontWeight:"bold"}}>Activities: </span>Robot Sumo Competition, IEEE, Tutor</li>
                </ul>
                <button className="btn btn-info me-2" onClick={() => openModal("/papers/Official_Transcript_AUB.pdf")}>View Transcript</button>
                <button className="btn btn-info" onClick={()=>setAubInfo((prev:any)=>!prev)}>Learn More</button>
              </div>
              {aubInfo && (
              <div style={{  display: "flex", 
                justifyContent: "center", 
                alignItems: "center", }}>
                <div className="alert alert-info w-100"  style={{position:"absolute", maxWidth:"500px"}}>
                    <button
                        className="btn-close float-end"
                        onClick={() => setAubInfo(false)}
                    ></button>
                <p style={{overflow:"wrap", maxWidth:"500px"}}>At the American University of Beirut (AUB), I engaged in a variety of activities that shaped my academic journey. 
                  I enrolled in an engineering course where I participated in a robot sumo competition, designing and building a robot using LEGO Mindstorms and LabView. 
                  In addition to this, I was an active member of the IEEE club, which provided me with opportunities to collaborate on technical projects and network with industry professionals. 
                  I also worked as a private tutor for the Introduction to Programming and Electronics Circuit courses, helping fellow students grasp challenging concepts.
                  I had to transfer from AUB in Spring of 2021 <a href="#/Rayan/About" style={{textDecoration:"none"}}>(About Me <ImNewTab className="mb-1"/>)</a>.
                </p>
                </div>
              </div>
            )}
            </div>
          
            <img src="/images/aub.png" alt="aub logo"/>


          </div>

          <div className="arrow mb-5"><FaAnglesUp className="fs-1"/></div>

          <div className="clw" >
            
            <img src="/images/clw.png" alt="clw logo"/>

            <div className="clw-container">
              <h5>Collège Louise Wegmann (2004-2019)</h5>
              <div className="clw-info">
                <ul>
                  <li><span style={{fontWeight:"bold"}}>Diplomas: </span> High School Diploma, French Baccalaureate</li>
                  <li><span style={{fontWeight:"bold"}}>Specialization: </span>Scientific-Mathematics</li>
                  <li><span style={{fontWeight:"bold"}}>Activities: </span>Taekwondo (2010-2014), Piano (2008-2015), <button className="btn btn-link mb-1" style={{padding:"0", margin:"0", textDecoration:"none"}} onClick={() => window.open("https://thelittleengineer.com/", "_blank")}>Little Engineer <LuLogOut className="mb-1"/></button> (Took a course in Java in 2018), Cinematography & Visual Arts (French Baccalaureate)</li>
                </ul>
                <button className="ms-4 btn btn-info me-2" onClick={() => openModal("/images/CLWdiploma.jpeg")}>View Diploma</button>
                <button className="btn btn-info me-2" onClick={() => openModal("/papers/FrenchBac.pdf")}>French Bac.</button>
                <button className="btn btn-info me-2" onClick={() => openModal("/papers/CLW_Transcript.pdf")}>View Transcript</button>

              </div>


            </div>
 

          </div>







    </div>

    <div className="custom-shape-divider-top-1735500841-2 border-0" >
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" >
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-border" ></path>
          
      </svg>
    </div>



      <div className="activities-section">

        <h1 className="activities-title">ACTIVITIES</h1>

        <div className="activities-grid mb-5">

            <div className="card rounded-3 overflow-hidden ms-4 mt-3" style={{width:"200px"}}>
              <a href="#/Rayan/Piano" style={{textDecoration:"none", color:"black"}}>
              <img src="/images/piano1.png" alt="" className="card-img-top " style={{width: "100%", height: "250px", objectFit: "cover" }}/>
              <h1>Piano</h1></a>
            </div>
            <div className="card rounded-3 overflow-hidden ms-4 mt-3" style={{width:"200px"}} >
            <a href="#/Rayan/Volunteer" style={{textDecoration:"none", color:"black"}}>
              <img src="/images/v2.PNG" alt="" className="card-img-top" style={{position:"relative", width: "100%", height: "250px", objectFit: "cover" }}/>
              <h1>Volunteer</h1></a>
            </div>
            <div className="card rounded-3 overflow-hidden ms-4 mt-3" style={{width:"200px"}}>
            <a href="#/Rayan/Travel" style={{textDecoration:"none", color:"black"}}>
              <img src="/images/travel.jpeg" alt="" className="card-img-top" style={{ width: "100%", height: "250px", objectFit: "cover" }}/>
              <h1>Travel</h1></a>
            </div>
            <div className="card rounded-3 overflow-hidden ms-4 mt-3" style={{width:"200px"}}>
            <a href="#/Rayan/Fitness" style={{textDecoration:"none", color:"black"}}>
              <img src="/images/fitness.jpeg" alt="" className="card-img-top" style={{ width: "100%", height: "250px", objectFit: "cover" }}/>
              <h1>Fitness</h1></a>
            </div>


            </div>
      {showModal && currentPdf && (
        <div className="modal show" style={{ display: 'block' }} onClick={closeModal}>
          <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <button className="btn-close" onClick={closeModal}>
                <IoMdClose className='mb-3'/>
                </button>
              </div>
              <div className="modal-body">
              {isMobile ? (
                    <div>
                    <p>Viewing the PDF on mobile or tablet may be limited. Please open it in fullscreen:</p>
                    <a
                        href={currentPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                    >
                        Open PDF
                    </a>
                    </div>
                ) : (
                    <iframe
                    src={currentPdf}
                    width="100%"
                    height="500px"
                    title="Research Paper"
                    />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
   

</>
  );
}





